export default "/static/media/success.f76f90451f8db265a1643737f3296b3b.svg";